import { clone, unionBy } from 'lodash';

const updateByProp = (arr, uniqId, prop, update) => {
  const i = arr.findIndex(el => el[prop] === uniqId);

  if (i === -1) return arr;

  return [...arr.slice(0, i), { ...arr[i], ...update }, ...arr.slice(i + 1)];
};

// eslint-disable-next-line complexity
export default function careerCenter(
  state = {
    isSubmittingQuestionData: false,
    militaryIsToggled: false,
    hasMentorVideo: false,
    localCareers: [],

    stateStats: null,
    trendContext: null,

    careers: [],
    page: 0,
    ordering: { by: 'growth', order: 'dsc' },
    filter: {},
    count: 0,

    militaryClustersToggled: false,
  },
  action,
) {
  const updatedState = clone(state);
  switch (action.type) {
    case 'CAREER_TOGGLE_MILITARY_CLUSTERS':
      return {
        ...state,
        militaryClustersToggled: !state.militaryClustersToggled,
      };

    case 'CAREER_TOGGLE_MILITARY':
      updatedState.militaryIsToggled = !updatedState.militaryIsToggled;
      if (updatedState.hasMentorVideo) {
        updatedState.hasMentorVideo = false;
      }
      return updatedState;

    case 'CAREER_TOGGLE_HAS_MENTOR_VIDEOS':
      updatedState.hasMentorVideo = !updatedState.hasMentorVideo;
      if (updatedState.militaryIsToggled) {
        updatedState.militaryIsToggled = false;
      }
      return updatedState;

    case 'CAREER_HOT_DATA_POPULATE':
      updatedState.hotCareers = action.data;
      return updatedState;

    case 'CAREER_FAVORITE_DATA_POPULATE':
      updatedState.favoriteCareers = action.data;
      return updatedState;

    case 'CAREER_SPECIFIC_DATA_POPULATE':
      updatedState.specificCareer = action.data;
      return updatedState;

    case 'MILITARY_CAREER_SPECIFIC_DATA_POPULATE':
      updatedState.specificMilitaryCareer = action.data;
      return updatedState;

    case 'RESET_SPECIFIC_MILITARY_CAREER':
      updatedState.specificMilitaryCareer = null;
      return updatedState;

    case 'MILITARY_CAREER_ALL_DATA_POPULATE':
      updatedState.militaryCareers = action.data;
      return updatedState;

    case 'CAREER_CLUSTER_PAGE_POPULATE':
      updatedState.clusterCareers = action.data;
      return updatedState;

    case 'CAREER_STATE_DATA_POPULATE':
      updatedState.stateCareers = action.data;
      return updatedState;

    case 'CLUSTER_ALL_DATA_POPULATE':
      updatedState.allClusters = action.data;
      return updatedState;

    case 'POPULATE_SEARCHED_CAREERS':
      updatedState.searchedCareers = action.data;
      return updatedState;

    case 'POPULATE_SEARCHED_MILITARY_CAREERS':
      updatedState.searchedMilitaryCareers = action.data;
      return updatedState;

    case 'CAREERS_ADD_FAVORITES_SUCCESS': {
      const { uuid } = action.data;
      const newFavoriteCareer = state.allCareers.find(c => c.uuid === uuid);

      return {
        ...state,
        favoriteCareers: {
          civilianCareers: [
            ...state.favoriteCareers.civilianCareers,
            newFavoriteCareer,
          ],
          militaryCareers: state.favoriteCareers.militaryCareers,
        },
      };
    }

    case 'CAREERS_REMOVE_FAVORITES_SUCCESS': {
      const { uuid } = action.data;
      return {
        ...state,
        favoriteCareers: state.favoriteCareers.filter(c => c.uuid !== uuid),
      };
    }

    case 'CAREERS_ADD_QUESTION_SUCCESS': {
      return {
        ...state,
        isSubmittingQuestionData: action.mode,
      };
    }

    case 'CAREERS.POPULATE_CAREER_INFO':
      return {
        ...state,
        localCareers: action.info,
      };

    case 'CAREERS.RESET_CAREER_TRENDS':
      return {
        ...state,
        stateTrends: null,
        trendContext: null,
      };

    case 'CAREERS.POPULATE_TREND_CONTEXT':
      return {
        ...state,
        trendContext: action.trendContext,
      };

    case 'CAREERS/HARD_RESET_CAREERS_LIST':
      return {
        ...state,
        careers: [],
        page: 0,
        ordering: { by: 'growth', order: 'dsc' },
        filter: {},
        count: 0,
        militaryIsToggled: false,
      };

    case 'CAREERS/SOFT_RESET_CAREERS_LIST':
      return {
        ...state,
        careers: [],
        page: 0,
      };

    case 'CAREERS/INC_PAGE':
      return {
        ...state,
        page: state.page + 1,
      };

    case 'CAREERS/MERGE_NEW_CAREERS':
      return {
        ...state,
        careers: unionBy(state.careers, action.results, 'uuid'),
        count: action.count,
      };

    case 'CAREERS/UPDATE_NEW_CAREERS':
      return {
        ...state,
        careers: action.careers,
        count: action.count,
      };

    case 'CAREERS/SET_ORDERING':
      return {
        ...state,
        ordering: action.ordering,
      };

    case 'CAREERS/SET_FILTER':
      return {
        ...state,
        filter: action.filter,
      };

    case 'CAREERS/UPDATE_INDIVIDUAL_CAREER':
      return {
        ...state,
        careers: updateByProp(
          state.careers,
          action.uuid,
          'uuid',
          action.update,
        ),
      };

    default:
      return state;
  }
}
